import jwt_decode from "jwt-decode";

const isAuthenticated = () => {
  if (localStorage.getItem("token") !== null) return true;
  else return false;
};

const isPrivilegedUser = () => {
  if (localStorage.getItem("token") !== null) {
    const userToken = JSON.parse(localStorage.getItem("token").toString());
    let decoded = jwt_decode(userToken.token);
    if (decoded.malote_escrever === 1) return true;
    else return false;
  }
};

export default { isAuthenticated, isPrivilegedUser };
